/**
 * Supabase Client - Browser/Client Components
 * 
 * This client is used in Client Components (components that run in the browser).
 * It automatically handles auth state and session management.
 * Uses browser cookies for auth persistence.
 */

import { createBrowserClient } from "@supabase/ssr";
import type { Database } from "./database.types";

// Create a singleton browser client for client components
export function createClient() {
  return createBrowserClient<Database>(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    // New publishable key; legacy anon JWT kept as fallback during migration.
    (process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY ??
      process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY)!
  );
}



